module.exports = __webpack_public_path__ + "img/resize_small.6d180238.svg";